"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Log;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _log_css = _interopRequireDefault(require("wapplr/dist/common/log/log_css.js"));
var _getUtils = _interopRequireDefault(require("../Wapp/getUtils"));
var _Wapp = require("../Wapp");
var _Logo = _interopRequireDefault(require("../Logo"));
var _Template = _interopRequireDefault(require("../Template"));
function DefaultParent(props) {
  return _react["default"].Children.only(props.children);
}
function Log(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var wapp = context.wapp,
    req = context.req,
    res = context.res;
  var utils = (0, _getUtils["default"])(context);
  var _props$Logo = props.Logo,
    Logo = _props$Logo === void 0 ? _Logo["default"] : _props$Logo,
    subscribe = props.subscribe;
  var Parent = typeof props.Parent == "undefined" ? _Template["default"] : props.Parent === null ? DefaultParent : props.Parent;
  var _useState = (0, _react.useState)(utils.getRequestUrl()),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    stateUrl = _useState2[0],
    setUrl = _useState2[1];
  function onLocationChange(newUrl) {
    if (stateUrl !== newUrl) {
      setUrl(newUrl);
    }
  }
  (0, _react.useEffect)(function didMount() {
    var unsub = subscribe ? subscribe.locationChange(onLocationChange) : null;
    return function willUnmount() {
      if (unsub) {
        unsub();
      }
    };
  }, [stateUrl]);
  var styles = wapp.styles;
  var _req$wappRequest = req.wappRequest,
    remoteAddress = _req$wappRequest.remoteAddress,
    httpVersion = _req$wappRequest.httpVersion,
    method = _req$wappRequest.method,
    url = _req$wappRequest.url,
    timestamp = _req$wappRequest.timestamp;
  var _res$wappResponse = res.wappResponse,
    _res$wappResponse$sta = _res$wappResponse.statusCode,
    statusCode = _res$wappResponse$sta === void 0 ? 200 : _res$wappResponse$sta,
    _res$wappResponse$sta2 = _res$wappResponse.statusMessage,
    statusMessage = _res$wappResponse$sta2 === void 0 ? "" : _res$wappResponse$sta2,
    _res$wappResponse$err = _res$wappResponse.errorMessage,
    errorMessage = _res$wappResponse$err === void 0 ? "" : _res$wappResponse$err;
  var text = "[LOG] [".concat(timestamp, " - ").concat(remoteAddress, "] HTTP:").concat(httpVersion, " ").concat(method, " ").concat(url || "/", " -> [").concat(statusCode, "] ").concat(errorMessage || statusMessage);
  styles.use(_log_css["default"]);
  return /*#__PURE__*/_react["default"].createElement(Parent, Object.assign({}, props, {
    subscribe: null
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _log_css["default"].log
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _log_css["default"].logo
  }, Logo ? /*#__PURE__*/_react["default"].createElement(Logo, null) : null), /*#__PURE__*/_react["default"].createElement("div", null, text)));
}